import React, { useContext } from "react";
import TrackingProductItem1 from "./TrackingProductItem1";
import TrackingProductItem2 from "./TrackingProductItem2";
import TrackingProductItem3 from "./TrackingProductItem3";
import TrackingProductItem4 from "./TrackingProductItem4";
import TrackingProductItem5 from "./TrackingProductItem5";
import TrackingProductItem6 from "./TrackingProductItem6";
import { Reveal } from "react-reveal";
import { LocationContext } from "../../store/LocationContext";

const TrackingProduct = () => {
    const { location } = useContext(LocationContext);

    let imgFolder = "";
    let imgLocation = "";

    if (location === "") {
        imgFolder = "services-home";
        imgLocation = "home";
    } else if (location === "Acacia Ridge") {
        imgFolder = "services-acacia";
        imgLocation = "acacia";
    } else if (location === "Brisbane") {
        imgFolder = "services-brisbane";
        imgLocation = "brisbane";
    } else if (location === "Beenleigh") {
        imgFolder = "services-beenleigh";
        imgLocation = "beenleigh";
    } else if (location === "Coopers Plains") {
        imgFolder = "services-coopers";
        imgLocation = "coopers";
    } else if (location === "Gold Coast") {
        imgFolder = "services-goldcoast";
        imgLocation = "goldcoast";
    } else if (location === "Ipswich") {
        imgFolder = "services-ipswich";
        imgLocation = "ipswich";
    } else if (location === "Rocklea") {
        imgFolder = "services-rocklea";
        imgLocation = "rocklea";
    } else if (location === "Sunnybank") {
        imgFolder = "services-sunnybank";
        imgLocation = "sunnybank";
    } else if (location === "Toowoomba") {
        imgFolder = "services-toowoomba";
        imgLocation = "toowoomba";
    } else if (location === "Underwood") {
        imgFolder = "services-underwood";
        imgLocation = "underwood";
    } else if (location === "Woodridge") {
        imgFolder = "services-woodridge";
        imgLocation = "woodridge";
    }

    return (
        <section id="services" className="tracking_product_area sec_pad">
            <div className="container">
                <div className="hosting_title chat_title text-center">
                    <Reveal effect="fadeInUp" duration={3000}>
                        <h2 className="wow fadeInUp" data-wow-delay="0.2s">
                            <span>Our Services</span>
                        </h2>
                    </Reveal>
                </div>
                <Reveal effect="fadeInUp" duration={1500}>
                    <div className="row mb-3">
                        <div className="col-lg-6 mb-3">
                            <TrackingProductItem1
                                itemClass="tracking_pr_two"
                                rowclass="flex-column"
                                image={`${imgFolder}/block-1-${imgLocation}.png`}
                            />
                        </div>
                        <div className="col-lg-6">
                            <TrackingProductItem2
                                itemClass="tracking_pr_two"
                                rowclass="flex-column"
                                image={`${imgFolder}/block-2-${imgLocation}.png`}
                            />
                        </div>
                    </div>
                </Reveal>
                <Reveal effect="fadeInUp" duration={1500}>
                    <div className="row mb-3">
                        <div className="col-lg-6 mb-3">
                            <TrackingProductItem3
                                itemClass="tracking_pr_two"
                                rowclass="flex-column"
                                image={`${imgFolder}/block-3-${imgLocation}.png`}
                            />
                        </div>
                        <div className="col-lg-6">
                            <TrackingProductItem4
                                itemClass="tracking_pr_two"
                                rowclass="flex-column"
                                image={`${imgFolder}/block-4-${imgLocation}.png`}
                            />
                        </div>
                    </div>
                </Reveal>
                <Reveal effect="fadeInUp" duration={1500}>
                    <div className="row mb-3">
                        <div className="col-lg-6 mb-3">
                            <TrackingProductItem5
                                itemClass="tracking_pr_two"
                                rowclass="flex-column"
                                image={`${imgFolder}/block-5-${imgLocation}.png`}
                            />
                        </div>
                        <div className="col-lg-6">
                            <TrackingProductItem6
                                itemClass="tracking_pr_two"
                                rowclass="flex-column"
                                image={`${imgFolder}/block-6-${imgLocation}.png`}
                            />
                        </div>
                    </div>
                </Reveal>
            </div>
        </section>
    );
};

export default TrackingProduct;
